import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import moment from 'moment';

export type PeriodSelectType = {
  start: Date | null,
  end: Date | null
}

const PERIODS = [
  'actual_month',
  'last_month',
  'actual_quarter',
  'last_quarter',
  'actual_year',
  'last_year',
];

@Component({
  selector: 'app-reporting-date-selector',
  templateUrl: './reporting-date-selector.component.html',
  styleUrls: ['./reporting-date-selector.component.scss']
})
export class ReportingDateSelectorComponent implements OnInit {

  @Input() visible: boolean;
  @Input() field: string;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() periodSelected = new EventEmitter<PeriodSelectType>();

  @ViewChild('select') select: ElementRef;

  public form: UntypedFormGroup = this.fb.group({
    start: new UntypedFormControl(null),
    end: new UntypedFormControl(null),
  });
  public periods = PERIODS;
  public actualPeriod: string | null = null;

  constructor(
    private fb: UntypedFormBuilder,
  ) { }

  ngOnInit(): void {
  }

  public emitOnHide(): void {
    this.visibleChange.emit(false);
  }

  public onCancel(): void {
    this.visible = false;
    this.emitOnHide();
  }

  public onSelect(): void {
    this.periodSelected.emit({
      start: (this.form.get('start').value) ? moment(this.form.get('start').value).startOf('day').toDate() : null,
      end: (this.form.get('end').value) ? moment(this.form.get('end').value).endOf('day').toDate() : null,
    });
  }

  public selectPeriod(period: string | null): void {
    this.actualPeriod = period;
    if (period !== null) {
      this.setForm(period);
    }
    this.select.nativeElement.focus();
  }

  private setForm(period: string): void {
    let start = null;
    let end = null;
    switch (period) {
      case 'actual_month': {
        start = moment().startOf('month').toDate();
        end = moment().endOf('month').toDate();
        break;
      }
      case 'last_month': {
        start = moment().subtract(1, 'months').startOf('month').toDate();
        end = moment().subtract(1, 'months').endOf('month').toDate();
        break;
      }
      case 'actual_quarter': {
        start = moment().startOf('quarter').toDate();
        end = moment().endOf('quarter').toDate();
        break;
      }
      case 'last_quarter': {
        start = moment().subtract(1, 'quarters').startOf('quarter').toDate();
        end = moment().subtract(1, 'quarters').endOf('quarter').toDate();
        break;
      }
      case 'actual_year': {
        start = moment().startOf('year').toDate();
        end = moment().endOf('year').toDate();
        break;
      }
      case 'last_year': {
        start = moment().subtract(1, 'years').startOf('year').toDate();
        end = moment().subtract(1, 'years').endOf('year').toDate();
        break;
      }
    }
    this.form.patchValue({
      start,
      end
    });
  }

}
